import React, { useEffect, useState } from "react";
import RegionService from "../../../Services/RegionService";
import { IoMdArrowDropdown } from "react-icons/io";
import Australia from "../../../assets/img/mapicons/Australia.png";
import Asia from "../../../assets/img/mapicons/Asia.png";
import Africa from "../../../assets/img/mapicons/Africa.png";
import Europe from "../../../assets/img/mapicons/Europe.png";
import Balkans from "../../../assets/img/mapicons/Balkans.png";
import Caribbean from "../../../assets/img/mapicons/Caribbean.png";
import Caucasus from "../../../assets/img/mapicons/Caucasus.png";
import LatinAmerica from "../../../assets/img/mapicons/LatinAmerica.png";
import MiddleEast from "../../../assets/img/mapicons/MiddleEast.png";
import World from "../../../assets/img/mapicons/World.png";
import t20WcIcon from "../../../assets/img/mapicons/t20-wc-icon.jpg";
import MicroLoader from "../../Alert_Popup/MicroLoader";
import PlansTray from "./PlansTray";
import "../../../scss/flag-sprite.css"

const RegionalESim = ({
  isTopPlan,
  setRecurringModal,
  recurringModal,
  setModalData,
  openCoverageDropdown,
  setCurrentDetails,
  setDetailsOpen,
  suggestion,
  setSubPlan,
  subPlan,
  setShoweKycPopup,
  vendorId,
  resetTheFilterValue,
  setResetTheFilterValue
}) => {
  const [allRegionPlans, setAllRegionPlans] = useState([]);
  const [selectedRegionId, setSelectedRegionId] = useState();
  const [regionId, setRegionId] = useState([]);
  const [showPlansTray, setShowPlansTray] = useState(false);
  const [selectedRegion, setSelectedRegion] = useState(null);
  const [message, setMessage] = useState();
  const [statusCode, setStatusCode] = useState();

  const getAllRegions = () => {
    RegionService.regionList()
      .then((response) => {
        setAllRegionPlans(response.data);
      })
      .catch((error) => {
        if (error.message === "Network Error") {
          // setIsLoading(false);
          setMessage("Something went wrong, Please try again later");
        } else {
          setMessage(error.response.data.failedReason);
          setStatusCode(error.response ? error.response.status : "");
        }
      });
  };
  useEffect(() => {
    getAllRegions();
  }, []);
  useEffect(() => {
    if (suggestion) {
      if (allRegionPlans.length > 0) {
        const selectedCountry = allRegionPlans?.find(
          (item) => item.regionId == suggestion
        );
        setSelectedRegion(selectedCountry);
        setShowPlansTray(true);
      }
    }
  }, [suggestion, allRegionPlans]);
  return (
    <>
      {!showPlansTray ? (
        <>
          {allRegionPlans && allRegionPlans.length > 0 ? (
            <div className="regional-esim-destination mt-4">
              <div className="regional-plans-grid">
                {allRegionPlans.map((item, index) => (
                  <div
                    className={`grid-card h-auto ${
                      selectedRegionId === item.regionId ? regionId : ""
                    }`}
                    key={item.regionId}
                  >
                    <div className="w-100 h-auto py-2 d-flex justify-content-start align-items-center">
                      <span
                        className={`${
                          item.regionDescription == "Europe" ? "fflag-EU" : ""
                        } fflag ff-xl ff-round mr-2`}
                      >
                        {item.regionDescription != "Europe" ? (
                          <img
                            className="regionLogo"
                            src={
                              item.regionDescription == "Africa"
                                ? Africa
                                : item.regionDescription == "Asia"
                                ? Asia
                                : item.regionDescription == "Australia"
                                ? Australia
                                : item.regionDescription == "Caribbean"
                                ? Caribbean
                                : item.regionDescription == "Latin America"
                                ? LatinAmerica
                                : item.regionDescription == "Balkans"
                                ? Balkans
                                : item.regionDescription == "Caucasus"
                                ? Caucasus
                                : item.regionDescription == "Middle East"
                                ? MiddleEast
                                : item.regionDescription == "T20 WC Region 1"
                                ? t20WcIcon
                                : item.regionDescription == "T20 WC Region 2"
                                ? t20WcIcon
                                : World
                            }
                          />
                        ) : (
                          ""
                        )}
                      </span>
                      <div>
                        <p
                          onClick={() => {
                            setShowPlansTray(true);
                            setSelectedRegion(item);
                          }}
                          className="m-0 region-title"
                        >
                          {item.regionDescription}
                        </p>

                        {/* <div
                          onClick={() => {
                            openCoverageDropdown(index, item.regionId);
                            // open coverage dropdown here
                          }}
                          className="countries-label-dropdown d-flex justify-content-start align-items-center">
                          {item.countrys && (
                            <span>{item.countrys.length} Countries</span>
                          )}
                          <IoMdArrowDropdown />
                        </div> */}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ) : (
            <div
              className="d-flex justify-content-center align-items-center"
              style={{
                height: "250px",
              }}
            >
              <MicroLoader />
            </div>
          )}
        </>
      ) : (
        <PlansTray
          vendorId={vendorId}
          setShoweKycPopup={setShoweKycPopup}
          data={allRegionPlans}
          setShowPlansTray={setShowPlansTray}
          selected={selectedRegion}
          tab={"2"}
          setRecurringModal={setRecurringModal}
          recurringModal={recurringModal}
          setModalData={setModalData}
          setCurrentDetails={setCurrentDetails}
          setDetailsOpen={setDetailsOpen}
          setSubPlan={setSubPlan}
          subPlan={subPlan}
          isTopPlan={isTopPlan}
          resetTheFilterValue={resetTheFilterValue}
          setResetTheFilterValue={setResetTheFilterValue}
        />
      )}
    </>
  );
};

export default RegionalESim;
